module.exports = __webpack_public_path__ + "img/logo3.c6cf8e67.png";